export default "__VITE_ASSET__Fw62LQy4__"